import React, { useEffect, useState } from 'react'
import { Banner, Button } from '@shopify/polaris'
import { useAppBridge } from '@shopify/app-bridge-react'
import request from '../../../../lib/request'

export default function PixelSetupWarning() {
  const app = useAppBridge()
  const [attempt, setAttempt] = useState(0)
  const [state, setState] = useState('loading')
  useEffect(() => {
    let current = true
    setState('loading')
    Promise.resolve().then(() => request('activate-webpixel', 'POST', undefined, undefined, app))
      .then(result => {
        if (current) setState(result?.success ? 'ready' : 'error')
      }, () => { if (current) setState('error') })
    return () => { current = false }
  }, [app, attempt])
  if (state === 'ready' || (state === 'loading' && attempt === 0)) return null
  return <Banner status="warning" title="Storefront tracking setup is incomplete">
    <p>Analytics may stay at zero until tracking is connected. Retry setup. If it still fails, contact support to check the Shopify pixel extension.</p>
    <Button loading={state === 'loading'} disabled={state === 'loading'} onClick={() => setAttempt(value => value + 1)}>Retry tracking setup</Button>
  </Banner>
}
